/* eslint-disable import/prefer-default-export */
const authTokenKey = '__auth_token__';

const config = {
  defaultContextId: 1,
};

export { authTokenKey, config };
